import { useEffect, useRef } from "react";
import PropTypes from "prop-types";

export const useOutsideClick = (ref, cb) => {
    useEffect(() => {
        const handleOutsideClick = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                cb();
            }
        };
        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [ref, cb]);
};

const OutsideClickWrapper = ({ callback, children }) => {
    const wrapperRef = useRef(null);
    useOutsideClick(wrapperRef, callback);
    return <div ref={wrapperRef}>{children}</div>;
};

export default OutsideClickWrapper;

OutsideClickWrapper.propTypes = {
    callback: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired
};
